import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, Bug, ArrowRight, Cpu, Monitor } from 'lucide-react';

function Dashboards() {
  const navigate = useNavigate();

  const dashboards = [
    {
      id: 'test-report',
      title: 'Test Report',
      description: 'Apex Milestone test execution status, test cases by priority/module, and TestRail run progress.',
      icon: <BarChart3 size={32} />,
      color: '#2e7d32',
      path: '/dashboards/test-report',
    },
    {
      id: 'bug-dashboard',
      title: 'Bug Dashboard',
      description: 'Open defects by team, priority, and milestone. Track bug resolution and triage status.',
      icon: <Bug size={32} />,
      color: '#c62828',
      path: '/dashboards/bug-dashboard',
    },
    {
      id: 'fleet-manager',
      title: 'Fleet Manager',
      description: 'QA Lab lane allocation. See which POS/SCO lanes are free or in use, and claim a lane for testing.',
      icon: <Monitor size={32} />,
      color: '#1565c0',
      path: '/dashboards/fleet-manager',
    },
    {
      id: 'automation',
      title: 'Automation Dashboard',
      description: 'Automation coverage, status by module, bugs found by automation, and milestone breakdown.',
      icon: <Cpu size={32} />,
      color: '#6a1b9a',
      path: '/dashboards/automation',
    },
  ];

  return (
    <div className="dashboards-page">
      <div className="dashboards-header">
        <h2>Dashboards</h2>
        <p className="dashboards-subtitle">Select a dashboard to view detailed reports and metrics.</p>
      </div>
      <div className="dashboards-grid">
        {dashboards.map((d) => (
          <div
            key={d.id}
            className="dashboard-tile"
            onClick={() => navigate(d.path)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate(d.path)}
          >
            <div className="dashboard-tile-icon" style={{ backgroundColor: `${d.color}15`, color: d.color }}>
              {d.icon}
            </div>
            <div className="dashboard-tile-content">
              <h3 className="dashboard-tile-title">{d.title}</h3>
              <p className="dashboard-tile-desc">{d.description}</p>
            </div>
            <div className="dashboard-tile-arrow">
              <ArrowRight size={20} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboards;
